export const splitParagraph = (entry) => {
	const splitContainer = entry.target;
	if (splitContainer) {
		splitContainer.classList.add("ddiff-split-paragraph-animate");
	}
};

export const showSplitParagraphContent = () => {
	const splitContainers = document.querySelectorAll(".ddiff-split-content");
	splitContainers.forEach((splitContainer) => {
		splitContainer.classList.add("ddiff-split-paragraph-static");
	});
};
